
import { RevHorizontalSeriesBlock } from '@ds/components/HorizontalSeriesBlock'
import { RevHorizontalSeriesBlockItem } from '@ds/components/HorizontalSeriesBlockItem'
import { icons } from '@ds/main'

export default {
  components: {
    RevHorizontalSeriesBlockItem,
    RevHorizontalSeriesBlock,
  },
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    iconComponent: (iconName) => {
      return icons[iconName]
    },
  },
}
